/* Config Imports */
import AlertsRouteConfig from './alerts.route'; 
/* Module Imports */
import configurationsModule from './configurations/configurations.module';
import dashboardModule from './dashboard/dashboard.module';
import historicalModule from './historical-alerts/historical-alerts.module';
/* Component Imports */
import AlertsMaintenanceHistoryComponent from '../asset-dashboard/alerts-maintenance-history/alerts-maintenance-history.component';

const alertsModule = angular.module('app.alerts', [
    "ui.bootstrap",
    "ui.router",
    "gettext",
    configurationsModule,
    dashboardModule,
    historicalModule
])
/* Config */
.config(AlertsRouteConfig)
/* Components */
.component('alertsMaintenanceHistory', AlertsMaintenanceHistoryComponent);

export default alertsModule.name;
